import { render, staticRenderFns } from "./Japanese.vue?vue&type=template&id=0829172a&scoped=true&"
import script from "./Japanese.ts?vue&type=script&lang=ts&"
export * from "./Japanese.ts?vue&type=script&lang=ts&"
import style0 from "./Japanese.css?vue&type=style&index=0&id=0829172a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0829172a",
  null
  
)

export default component.exports